import { clienteService } from '@/services/clienteService';
import router from '../../router'
import Cliente from '@/domain/Cliente';

const getDefaultState = () => {
  return {
    clientes: [],
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  clientes: state => state.clientes,
  isClientesModified: state => !!state.isModified
};

const actions = {
  async sendClientesAPI({ state, commit }) {
    if (state.clientes.length) {
      for (const cliente of state.clientes) {
        try {
          const clienteInserido = await clienteService.sendClienteAPI(cliente);
          commit('UPDATE_CLIENTE', clienteInserido);
          commit('SET_IS_CLIENTES_MODIFIED', true);
        } catch (error) {
          console.log(error);
          commit('SHOW_SNACKBAR', { text: 'Ocorreu um erro ao inserir o cliente', status: 'error' });
        }
      }
      commit('SHOW_SNACKBAR', { text: 'Operação concluída com sucesso', status: 'success' });
    }
  },
  async sendClienteByIdAPI({ commit }, idClienteInterno) {
    try {
      const cliente = await clienteService.sendClienteByIdAPI(idClienteInterno);
      commit('UPDATE_CLIENTE', cliente);
      commit('SET_IS_CLIENTES_MODIFIED', true);
      return cliente;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async fetchClientes({ commit }) {
    try {
      const response = await clienteService.getClientes();
      commit('SET_CLIENTES', response);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchClientesAPI({ commit }) {
    try {
      const response = await clienteService.getClientesAPI();
      commit('SET_CLIENTES', response);
      commit('SET_IS_CLIENTES_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchClienteDetalhesAPI({ commit }, cliente) {
    try {
      const clienteDetalhes = await clienteService.getClienteDetalhesAPI(cliente.id_cliente);
      commit('UPDATE_CLIENTE', clienteDetalhes);
      commit('SET_IS_CLIENTES_MODIFIED', true);
      return clienteDetalhes;
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchClienteFinanceiroAPI({ commit }, cliente) {
    try {
      const updCliente = await clienteService.getClienteFinanceiroAPI(cliente.id_cliente);
      commit('UPDATE_CLIENTE', updCliente);
      commit('SET_IS_CLIENTES_MODIFIED', true);
      return updCliente;
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchClienteEnderecosAPI({ commit }, cliente) {
    try {
      const response = await clienteService.getClienteEnderecosAPI(cliente.id_cliente);
      const enderecos = process.env.NODE_ENV === 'production' ? response.data.result.Sql || [] : response.data.Sql || [];
      cliente.enderecos = enderecos && enderecos.length ? enderecos : [];
      await clienteService.updateCliente(cliente);
      commit('UPDATE_CLIENTE', cliente);
      commit('SET_IS_CLIENTES_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchClienteTelefonesAPI({ commit }, cliente) {
    try {
      const response = await clienteService.getClienteTelefonesAPI(cliente.id_cliente);
      const telefones = process.env.NODE_ENV === 'production' ? response.data.result.Sql || [] : response.data.Sql || [];
      cliente.telefones = telefones && telefones.length ? telefones : [];
      await clienteService.updateCliente(cliente);
      commit('UPDATE_CLIENTE', cliente);
      commit('SET_IS_CLIENTES_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchClienteEmailsAPI({ commit }, cliente) {
    try {
      const response = await clienteService.getClienteEmailsAPI(cliente.id_cliente);
      const emails = process.env.NODE_ENV === 'production' ? response.data.result.Sql || [] : response.data.Sql || [];
      cliente.emails = emails && emails.length ? emails : [];
      await clienteService.updateCliente(cliente);
      commit('UPDATE_CLIENTE', cliente);
      commit('SET_IS_CLIENTES_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async createCliente({ commit }, { idColaborador }) {
    const cliente = new Cliente();
    cliente.id_colaborador = +idColaborador;
    try {
      const id = await clienteService.addCliente(cliente);
      cliente.id_interno = id;
      commit('SET_CLIENTE', cliente);
      commit('SET_IS_CLIENTES_MODIFIED', true);
      router.push({ name: 'Cliente', params: { id: cliente.id_interno }}); 
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async updateCliente({ commit }, updCliente) {
    await clienteService.updateCliente(updCliente);
    commit('UPDATE_CLIENTE', updCliente);
    commit('SET_IS_CLIENTES_MODIFIED', true);
  },
  async deleteCliente({ commit }, id) {
    try {
      await clienteService.deleteCliente(id);
      commit('DELETE_CLIENTE', id);
      commit('SET_IS_CLIENTES_MODIFIED', true);
      // router.push({ name: 'Clientes' });
      // commit('SHOW_SNACKBAR', { text: 'Registro excluído com sucesso.', status: 'success' });
    } catch (error) {
      console.log(error);
      // commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  }
};

const mutations = {
  CLEAR_CLIENTES_STATE: state => Object.assign(state, getDefaultState()),
  SET_CLIENTES: (state, clientes) => state.clientes = clientes,
  SET_CLIENTE: (state, cliente) => state.clientes.push(cliente),
  UPDATE_CLIENTE: (state, updCliente) => {
    const index = state.clientes.findIndex(cliente => cliente.id_interno === updCliente.id_interno);
    if (index !== -1) state.clientes.splice(index, 1, updCliente);
  },
  DELETE_CLIENTE: (state, id) => state.clientes = state.clientes.filter(cliente => cliente.id_interno !== id),
  SET_IS_CLIENTES_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}